<template>
  <b-collapse :id="id" :accordion="accordion" :visible="isVisible" >
    <slot></slot>
  </b-collapse>
</template>

<script>
export default {
  name: 'collapse-item',
  props: ['id', 'accordion', 'visible'],
  computed: {
    isVisible: function () {
      return this.visible === 'true'
    }
  }
}
</script>

<style lang="scss" scoped>
  .collapsing {
    transition: all 300ms 0s ease;
    position: relative;
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/components/collapse/CollapseItem.vue